





































import { Component, Vue, Watch } from 'vue-property-decorator';
import { insuranceService } from '@/services/InsuranceService';
import InsuranceForm from '@/components/insurance/Form.vue';
import {
  Button,
  Card
} from 'element-ui';
import { portService } from '@/services/PortService';
import FetchShipmentInsurance from '@/graphql/queries/shipment/FetchShipmentInsurance.gql';
import FetchTokioMarineContracts from '@/graphql/queries/FetchTokioMarineContracts.gql';

import { InsuranceFormElement } from '@/types/types';
import {
  calculateInsurance_calculateInsurance,
  tokioMarineContracts_tokioMarineContracts,
  PlaceFields,
  TransportationTypeEnum,
  fetchShipmentForInsurance_shipments
} from '@/types/graphql/schemaTypes';
import gql from 'graphql-tag';

@Component({
  components: {
    InsuranceForm,
    'el-button': Button,
    'el-card': Card
  },
  apollo: {
    shipment: {
      query: FetchShipmentInsurance,
      prefetch: true,
      variables() {
        return {
          shipmentArgs: {
            shipmentId: this.$route.params.id
          }
        };
      },
      update: (data: any) => data && data.shipments && data.shipments[0],
      fetchPolicy: 'cache-and-network'
    },
    tokioMarineContracts: {
      query: FetchTokioMarineContracts,
      prefetch: true,
      fetchPolicy: 'cache-and-network'
    }
  }
}
)
export default class Insurance extends Vue {
  public result: calculateInsurance_calculateInsurance | null = null;

  public tokioMarineContracts: tokioMarineContracts_tokioMarineContracts[] | null = null;
  public insuranceData: any = {};
  private loading = false;
  private shipment: fetchShipmentForInsurance_shipments | null = null;

  public $refs!: {
    insuranceForm: InsuranceFormElement;
  };

  public loadSavedForm() {
    // load previously saved data if any
    if (this.shipment.insurancePolicy) {
      const savedForm = JSON.parse(this.shipment.insurancePolicy?.request);
      this.$refs.insuranceForm.loadSavedData(savedForm);
    }
  }

  public get shipmentId() {
    return this.$route.params.id;
  }

  public get complete() {
    return this.shipment?.insurancePolicy?.complete;
  }

  public refreshData(data: any) {
    this.insuranceData = data;
  }

  private alertError() {
    this.$store.dispatch('Alert/addAlert', {
      type: 'error',
      message: this.$t('error.push'),
      time: 2000
    });
  }

  /**
   *  Get a quote for insurance policy
   */
  public async calculate() {
    try {
      const formData = this.insuranceData;
      const res = await insuranceService.calculate(formData);
      if (res.data && res.data.calculateInsurance) {
        this.result = res.data.calculateInsurance;
        this.$store.dispatch('Alert/addAlert', {
          type: 'success',
          message: 'Got a quote!'
        });
      }
    } catch (err) {
      const gqlError = err.graphQLErrors[0];
      if (gqlError) {
        this.$store.dispatch('Alert/addAlert', {
          type: 'error',
          message: gqlError.extensions
            ? `${gqlError.extensions.error_code}: ${gqlError.extensions.error_description}`
            : gqlError.message
        });
      }
    }
  }

  /**
   *  Create an insurance policy
   */
  public async create() {
    try {
      const formData = this.insuranceData;
      const res = await insuranceService.create(this.shipmentId, formData);
      if (res.data && res.data.createInsurance) {
        this.$apollo.queries.shipment.refetch();
        this.$store.dispatch('Alert/addAlert', {
          type: 'success',
          message: 'Got a quote!'
        });
      }
    } catch (err) {
      const gqlError = err.graphQLErrors[0];
      if (gqlError) {
        this.$store.dispatch('Alert/addAlert', {
          type: 'error',
          message: gqlError.extensions
            ? `${gqlError.extensions.error_code}: ${gqlError.extensions.error_description}`
            : gqlError.message
        });
      }
    }
  }

  /**
   *  Cancel an insurance policy
   */
  public async cancel() {
    try {
      const res = await insuranceService.cancel(this.shipmentId);
      this.$apollo.queries.shipment.refetch();
      this.$store.dispatch('Alert/addAlert', {
        type: 'success',
        message: 'Cancelled the policy!'
      });
    } catch (err) {
      const gqlError = err.graphQLErrors[0];
      if (gqlError) {
        this.$store.dispatch('Alert/addAlert', {
          type: 'error',
          message: gqlError.extensions
            ? `${gqlError.extensions.error_code}: ${gqlError.extensions.error_description}`
            : gqlError.message
        });
      }
    }
  }

  /**
   *  Save the input of an insurance policy (but no submission nor calculation)
   */
  public async save() {
    try {
      const data = this.$refs.insuranceForm.dataForSaving();
      this.loading = true;

      const response = await insuranceService
        .save(this.shipmentId, data);

      if (response?.data?.saveInsurance) {
        this.$store.dispatch('Alert/addAlert', {
          type: 'success',
          message: this.$t('success.created'),
          time: 2000
        });
      } else {
        this.alertError();
      }
    } catch (error) {
      this.alertError();
    } finally {
      this.loading = false;
    }
  }
}
